import React, { useMemo } from 'react';

import { Filter } from '../../../../shared/icons';
import { ModalHeader } from '../../../../shared/modal/ModalHeader';
import { Position, PositionModal } from '../../../../shared/modal/PositionModal';
import { DropdownOption } from '../../../fields';
import { DatasetFieldType } from '../../../store';
import { CurrencyFilterType, DateFilterType, InstanceTableFilterType, NumberFilterType, TextFilterType, TimeFilterType, ValuationPercentageFilterType } from '../../store/filterTypes';
import { DropdownFilter } from './DropdownFilter';
import { TextFilter } from './TextFilter';
import styles from './TableInstanceFilters.module.scss';
import { TimeFilter } from './TimeFilter';
import { NumberFilter } from './NumberFilter';
import { DateFilter } from './DateFilter';
import { ValuationPercentageFilter } from './ValuationPercentageFilter';
import { CheckboxFilter } from './CheckboxFilter';
import { CurrencyFilter } from './CurrencyFilter';

interface TableFilterModalProps {
    position: Position | null;
    filterDropdownOptions?: DropdownOption[];
    closeModal: () => void;
    updateFilter: (value: InstanceTableFilterType) => void;
    removeFilter: () => void;
    filter: InstanceTableFilterType | null;
    testId: string;
    type: DatasetFieldType;
}

export const TableFilterModal: React.FC<TableFilterModalProps> = ({
    closeModal,
    position,
    filterDropdownOptions,
    updateFilter,
    removeFilter,
    filter,
    testId,
    type
}) => {
    const filterContent = useMemo(() => {
        switch (type) {
            case DatasetFieldType.DROPDOWN:
                return <DropdownFilter filter={filter as string[] | null} testId={testId} updateFilter={updateFilter} removeFilter={removeFilter} filterDropdownOptions={filterDropdownOptions || []} />;
            case DatasetFieldType.LONGTEXT:
            case DatasetFieldType.TEXT:
            case DatasetFieldType.WYSIWYG:
                return <TextFilter filter={filter as TextFilterType | null} testId={testId} updateFilter={updateFilter} removeFilter={removeFilter} />;
            case DatasetFieldType.TIME:
                return <TimeFilter filter={filter as TimeFilterType | null} testId={testId} updateFilter={updateFilter} removeFilter={removeFilter} />;
            case DatasetFieldType.NUMBER:
                return <NumberFilter filter={filter as NumberFilterType | null} testId={testId} updateFilter={updateFilter} removeFilter={removeFilter} />;
            case DatasetFieldType.DATE:
                return <DateFilter filter={filter as DateFilterType | null} testId={testId} updateFilter={updateFilter} removeFilter={removeFilter} />;
            case DatasetFieldType.CHECKBOX:
                return <CheckboxFilter filter={filter as boolean | null} testId={testId} updateFilter={updateFilter} removeFilter={removeFilter} />;
            case DatasetFieldType.VALUATION_PERCENTAGE:
                return <ValuationPercentageFilter filter={filter as ValuationPercentageFilterType | null} testId={testId} updateFilter={updateFilter} removeFilter={removeFilter} />;
            case DatasetFieldType.CURRENCY_AMOUNT:
                return <CurrencyFilter filter={filter as CurrencyFilterType | null} testId={testId} updateFilter={updateFilter} removeFilter={removeFilter} />;
            default:
                return null;
        }
    }, [filter, testId, updateFilter, removeFilter, filterDropdownOptions, type]);

    return (
        <PositionModal
            isOpen
            testId={testId}
            closeModal={closeModal}
            position={position}
            height='fit-content'
            width='300px'
        >
            <div className={styles.tableFilterModal}>
                <ModalHeader icon={Filter} label='Filter' iconSize={20} overflowTooltipClassName={styles.filterModalHeader} marginBottom='5px' testId={testId} />
                {filterContent}
            </div>
        </PositionModal>
    );
};
